import { request } from "../../utils/request";
import { versionfn } from "../../utils/version";
var version = versionfn.version;

// 初始化扩展根节点;
export function centerNodeExtend(data) {
  return request({
    url: `${version}/single/analysis/extend/rootVertex`,
    method: "post",
    data,
    timeout: 60000,
  });
}

// 扩展节点
export function childNodeExtend(data) {
  return request({
    url: `${version}/single/analysis/extend/vertex`,
    method: "post",
    data,
    timeout: 60000,
  });
}

// 地址分析-首笔流入交易信息
export function firstInflow(data) {
  return request({
    url: `${version}/data/analysis/address/firstInflow`,
    method: "post",
    data,
  });
}

// 根据币种查询交易对手信息
export function counterPartyByCurrency(data) {
  return request({
    url: `${version}/analysis/vertices/counterPartyByCurrency`,
    method: "post",
    data,
  });
}

//聚合边分页
export function sc_aggregateEdgePage(data) {
  return request({
    url: `${version}/analysis/aggregateMindEdge/page`,
    method: "post",
    data,
  });
}

//聚合边分页
export function sc_editCanvas(id, data) {
  return request({
    url: `${version}/manage/singleCanvases/${id}`,
    method: "put",
    data,
  });
}

//下载聚合边分页数据
export function sc_aggregateEdgedownload(data) {
  return request({
    url: `${version}/analysis/aggregateMindEdge/page/download`,
    method: "post",
    data,
    responseType: "blob",
    dataType: "json",
    headers: { "Content-Type": "application/json; application/vnd.ms-excel" },
  });
}

//级联币种选项数据
export function getCurrenciesOptions(data) {
  return request({
    url: `${version}/manage/canvases/cascading/currencies/options`,
    method: "post",
    data,
  });
}

// Bitcoin地址详情-交易分页
export function pageBitcoinAddressTransaction(data) {
  return request({
    url: `${version}/data/analysis/bitcoinAddress/pageBitcoinAddressTransaction`,
    method: "post",
    data,
  });
}
